// extracted by mini-css-extract-plugin
module.exports = {"container":"ShellHost_container__34n2O"};